import React from 'react'
import { ArrowLeft, RefreshCw, Search } from 'lucide-react'

interface FooterProps {
  onBack: () => void
  viewMode: 'overview' | 'detail'
  onRefresh: () => void
  onSearch: () => void
  refreshing: boolean
}

export function Footer({ onBack, viewMode, onRefresh, onSearch, refreshing }: FooterProps) {
  return (
    <footer className="border-t border-[#374151] pt-4">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          {viewMode === 'detail' && (
            <button
              type="button"
              onClick={onBack}
              className="px-4 py-2 bg-[#1f2937] hover:bg-[#374151] border border-[#374151] rounded-lg text-sm font-mono flex items-center gap-2 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Back
            </button>
          )}
        </div>

        <div className="flex items-center gap-2 flex-1 justify-center">
          <button
            type="button"
            onClick={onRefresh}
            disabled={refreshing}
            className="px-3 py-1.5 bg-[#1f2937] hover:bg-[#374151] border border-[#374151] rounded-lg text-xs font-mono flex items-center gap-1 transition-colors disabled:opacity-50"
          >
            <RefreshCw className={`w-3 h-3 ${refreshing ? 'animate-spin' : ''}`} />
            Refresh
          </button>
          <button
            type="button"
            onClick={onSearch}
            className="px-3 py-1.5 bg-[#1f2937] hover:bg-[#374151] border border-[#374151] rounded-lg text-xs font-mono flex items-center gap-1 transition-colors"
          >
            <Search className="w-3 h-3" />
            Search
          </button>
        </div>

        <div className="flex items-center gap-4 text-xs text-[#6b7280]">
          <kbd className="px-2 py-1 bg-[#0a0f1a] rounded border border-[#374151]">R</kbd>
          <span>Refresh</span>
          <span>•</span>
          <kbd className="px-2 py-1 bg-[#0a0f1a] rounded border border-[#374151]">/</kbd>
          <span>Search</span>
          <span>•</span>
          <kbd className="px-2 py-1 bg-[#0a0f1a] rounded border border-[#374151]">Esc</kbd>
          <span>Back</span>
        </div>
      </div>
    </footer>
  )
}
